export const INVITE_STATUS = {
    PENDING: 'pending',
    ACCEPTED: 'accepted',
    EXPIRED: 'expired',
    REVOKED: 'revoked',
} as const;

export const PARTNER_REQUEST = {
    APPROVED: 'approved',
    SENT: 'sent',
    NOT_SENT: 'not sent',
} as const;
